import styles from "../assets/css/HistoryData.module.css";
import { BASE_URL } from "../constants/constants";

const HistoryData = ({ trip, closeModal }) => {
  if (!trip) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.box}>
          <div className={styles.text}>Данные о поездке</div>
          <img
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
            onClick={closeModal}
          />
        </div>
        <div className={styles.block}>
          <img
            className={styles.avatar}
            src={
              trip.driver.ImageUrl && trip.driver.ImageUrl.trim() !== ""
                ? `${BASE_URL}/v0${trip.driver.ImageUrl}`
                : "/images/users.svg"
            }
            alt="avatar"
          />
          <div className={styles.block1}>
            <div className={styles.box4}>
              <div className={styles.text1}>Имя:</div>
              <div className={styles.text2}>
                {trip.driver.fullName || "Водитель"}
              </div>
            </div>
            <div className={styles.box4}>
              <div className={styles.text1}>Модель машины:</div>
              <div className={styles.text2}>{trip.driver.car}</div>
            </div>
            <div className={styles.box4}>
              <div className={styles.text1}>Номер машины:</div>
              <div className={styles.text2}>{trip.driver.carNumber}</div>
            </div>
            <div className={styles.box4}>
              <img
                className={styles.rateicon}
                src="/images/rating.svg"
                alt="star icon"
              />
              <div className={styles.text2}>{trip.driver.rate}</div>
            </div>
          </div>
        </div>
        <div className={styles.box2}>
          <div className={styles.box3}>
            <div className={styles.text1}>Начальный адрес:</div>
            <div className={styles.text2}>{trip.startAddress}</div>
          </div>
          <div className={styles.box3}>
            <div className={styles.text1}>Конечный адрес:</div>
            <div className={styles.text2}>{trip.endAddress}</div>
          </div>
          <div className={styles.box3}>
            <div className={styles.text1}>Длительность:</div>
            <div className={styles.text2}>{trip.duration} минут</div>
          </div>
          <div className={styles.box3}>
            <div className={styles.text1}>Расстояние:</div>
            <div className={styles.text2}>{trip.distance} км</div>
          </div>
          <div className={styles.box3}>
            <div className={styles.text1}>Стоимость:</div>
            <div className={styles.text2}>{trip.cost} 〒</div>
          </div>
          <div className={styles.box3}>
            <div className={styles.text1}>Тип оплаты:</div>
            <div className={styles.text2}>
              {trip.paymentType}/{trip.isPaid ? "Оплачено" : "Не оплачено"}
            </div>
          </div>
        </div>
        <div className={styles.box1}>
          <button className={styles.deletebtn} onClick={closeModal}>
            Назад
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoryData;
